
import { defineComponent } from 'vue'
import { colors } from '@/data/colors'

export default defineComponent({
  props: {
    repo: {
      type: Object as () => { name: string; language: string },
      required: true,
    },
  },
  data() {
    return { colors }
  },
})
